import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'

@InputType()
export class UpdateItemStatusByTasksServiceArgs extends ActionArgs {
  @Field(() => String)
  _id: string
}

export interface IUpdateItemStatusByTasksService extends IAction<void, UpdateItemStatusByTasksServiceArgs> {}
